import React from 'react';

import { Apify } from '../Apify';
import Logo from './Logo';
import { R } from '../routes';
import I18N from '../I18N';
import { T } from '../traks';
import {setCommodityName} from '../misc'


var LogoAndInfo = (props) => {
	let size = props.logo_size || 60;
	let css_name = props.css_name || "ad_chart_h1";
	let css_ticker = props.css_ticker || "ad_chart_h2";
	let name = props.name || props.Name;
    let tempName = name;
    let ticker = props.ticker;
    let isPremium = props.isPremium ? props.isPremium : false;
	let beta = props.beta;
    let type = props.stockType;
    let showNotification = props.showNotification ? props.showNotification : false; 

    const typeGetter = () => {
        if (type === 'ETF') {
            return <T>ETF</T>
        } else if (type === 'Index') {
            return <T>Index</T>
        } else if (type === 'Commodity') {
            return <T>Commodity</T>
        } else if (type === 'Funds/Obligations') {
            return <T>Funds / Bonds</T>
        } else {
            return <T>Stock</T>
        }
    }

    
    if (type === 'Commodity') {
        tempName = setCommodityName(ticker, name);
    }

	if(props.add_ellipsis2name) {
		name = (
			<span className="text-overflow-dynamic-container">
				<span className="text-overflow-dynamic-ellipsis ">
					{tempName}
				</span>
			</span>
		);
	}

	return (
		<div className="d-flex flex-grow-1">
			<div className="d-flex flex-grow-1 flex-column align-self-center">
				<div className={css_name}>
					{tempName}
				</div>
				<div className={css_ticker}>
					{ticker} - {typeGetter()}
				</div>
                {isPremium === true && beta !== 0 ? 
                    <div className="ad_beta_score">
                        <T>Risk score</T>: <span className={beta < 0 ? 'beta-red' : (beta <= 1 ? 'beta-green' : 'beta-red')}>
                        {I18N.floatval(beta, 2)}</span>
                    </div> : null
                }
                {showNotification === true && isPremium === true && beta <= 0 ? 
                    <div>
                        <span className={css_ticker}><T>If your game has risk-adjusted return enabled, this asset cannot be traded.</T></span>
                    </div> : null
                }
                {showNotification === true && type === 'Commodity' ?
                    <div>
                        <T>This commodity follows the ETF – {name}, which follows the price of the commodity. There may therefore be a deviation.</T>
                    </div>
                : null}
			</div>
		</div>
	);
}

var LogoAndInfoExport = (props) => {
    if (props.hasData === false) {
        return Apify("/z/stock_info")
            .with_query_from_props(props => ({exchange: props.exchange, ticker: props.ticker, lang: R.get_current_language()}))
            .with_props_from_response(response => {
                return {
                    name: response.Name,
                    beta: response.BetaValue,
                    rate: response.Rate,
                    stockType: response.StockType
                };
            })
            .wrap(responseProps => <LogoAndInfo {...props} {...responseProps} />);
    } else {
        return <LogoAndInfo {...props} />
    }
}

export default LogoAndInfoExport



// WEBPACK FOOTER //
// ./src/c/LogoAndInfo.js